import { gql, TypedDocumentNode } from "@apollo/client";

import {
  GetDefaultPhoneNumberQuery,
  GetDefaultPhoneNumberQueryVariables,
} from "./DefaultPhoneNumber.generated";

export const GET_DEFAULT_PHONE_NUMBER: TypedDocumentNode<
  GetDefaultPhoneNumberQuery,
  GetDefaultPhoneNumberQueryVariables
> = gql`
  query GetDefaultPhoneNumber($countryCode: String!) {
    defaultPhoneNumber(countryCode: $countryCode)
  }
`;
